import { useState, useEffect } from 'react';
import ConfirmStage from './ConfirmStage/ConfirmStage';
import PasswordStage from './PasswordStage/PasswordStage';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../components/Loader/Loader';
import { useSearchParams, useParams, useLocation } from 'react-router-dom';
import { log } from "../../../../utils/logger";
/**
* Create account form
* @returns TSX.Element
*/
const CreateAccountForm = () => {
    const { t } = useTranslation(); // Translation
    const { stage } = useParams();
    const location = useLocation();
    const [otp, setOtp] = useState<string | null>(null)
    const [searchParams, setSearchParams] = useSearchParams(); // For ?stage=reset param
    const [success, setSuccess] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false); // Loading state


    // tohle asi bude pryc
    const handleAccountCreated = () => {
        setSuccess(true);
    };

    // Set email from otp
    useEffect(() => {
        const hasOtp = !!searchParams.get('otp');
        if (hasOtp) {
            log("Current otp parameter: " + searchParams.get('otp'))
            setOtp(searchParams.get('otp'))
        }else  {
            log("Otp parameter missing.")
        }
    }, [stage, searchParams, location.pathname]);




    return (
        <>
            {loading && <Loader text={t("create_account.loading")} />}
            {success ? (
                <ConfirmStage />
            ) : (
                <PasswordStage otp={otp} setLoading={setLoading} onAccountCreated={handleAccountCreated} />
            )}
        </>
    )
};

export default CreateAccountForm;
